import "reflect-metadata";
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
// @ts-ignore
import VueMask from "v-mask";
Vue.use(VueMask);
import store from "@/store";
// Import styles from
import "@/styles/main.scss";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Formatter } from "@/plugins/formatter";
import "@/directives/vue-click-outside";
import { _moment as moment } from "@/utils/moment";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

Vue.prototype.moment = moment;
Vue.prototype.$converter = new Formatter();
Vue.prototype.$translate = LocalesFields;
declare module "vue/types/vue" {
  interface Vue {
    moment: typeof moment;
    $converter: {
      date(value: string | Date): Date;
      price(value: number): number | string;
      setPrice(value: number): number;
      getPrice(value: number): number;
      phone(value: any): string;
      translate(value?: string): string;
      limitedOutput(value: string, countSymbols?: number): string;
    };
    $translate: typeof LocalesFields;
  }
}
Vue.component("v-select", vSelect);

Vue.config.productionTip = false;

// Register VueJS plugins
Vue.use(BootstrapVue);

export default function() {
  // Init Vue app
  return new Vue({
    i18n,
    store,
    router,
    render: h => h(App)
  }).$mount("#app");
}
